import { useQuery, useQueryClient } from "@tanstack/react-query";
import { boronClient } from "../../api";
import { createError, HTTPErrors } from "../../errors";
import { StudyRecordWithRestrictedAttributes } from "../../interfaces/StudyRecordInterface";
import { paths } from "../../lib/api/v1";

type Props = {
  studentId: string;
  studyRecordId: string;
};

export type StudentStudyRecordResponse =
  paths[Url]["get"]["responses"]["200"]["content"]["application/json"]["studyRecord"];

const URL = "/api/v1/students/{student_id}/study_records/{study_record_hashid}";
type Url = typeof URL;
export const useFetchStudentStudyRecord = ({
  studentId,
  studyRecordId,
}: Props) => {
  const { data, ...result } = useQuery<StudentStudyRecordResponse, HTTPErrors>({
    queryKey: [URL, studentId, studyRecordId],
    queryFn: async () => {
      const { data, response } = await boronClient.GET(URL, {
        params: {
          path: { student_id: studentId, study_record_hashid: studyRecordId },
        },
      });
      if (response.ok && data) {
        return data.studyRecord;
      }
      throw await createError(response);
    },
  });

  const queryClient = useQueryClient();
  const updateStudyRecordQueryCache = (
    newStudyRecord: StudyRecordWithRestrictedAttributes,
  ) => {
    queryClient.setQueriesData<StudentStudyRecordResponse>(
      { queryKey: [URL, studentId, studyRecordId] },
      (oldData) => {
        if (!oldData) {
          return oldData;
        }
        return newStudyRecord;
      },
    );
  };
  return {
    data,
    updateStudyRecordQueryCache,
    ...result,
  };
};
